import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePromise } from "../../../Utils/usePromise";
import axios from "axios";
import Card from "reactstrap/es/Card";
import CardTitle from "reactstrap/es/CardTitle";
import Spinner from "reactstrap/es/Spinner";
import CardText from "reactstrap/es/CardText";
import { parseApiError } from "@yooink/youtils/es/ErrorHandler";
import { BaseBadge } from "./BaseBadge";
export function ClientsCount(props) {
    const { isLoading, isError, data = {}, errData } = usePromise(() => {
        return axios.get(`/api/v2/analytics/badges/users/${props.type}`, {
            params: {
                from: props.from,
                to: props.to
            }
        })
            .then((res) => res.data);
    }, [props.from.getTime(), props.to.getTime()]);
    return (_jsxs(Card, Object.assign({ body: true, className: props.color }, { children: [_jsx(CardTitle, { children: props.caption }), isLoading && _jsx(Spinner, {}), !isLoading && isError && (_jsx(CardText, { children: parseApiError(errData) })), !isLoading && !isError && (_jsx(BaseBadge, { count: data.count, type: 'чел.' }))] })));
}
